import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {createProduct} from '../actions/products'
import ProductForm from '../components/ProductForm'

class NewProductModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/products')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        backdrop="static"
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.props.close}>Neues Produkt</ModalHeader>

        <ProductForm
          submit={this.handleSubmit}
          bodyComponent={ModalBody}
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}
export default connect(
  () => ({}),
  dispatch => ({
    submit: (payload) => dispatch(createProduct(payload))
  })
)(withSiteData(NewProductModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/NewProduct.js